/* sb-dc-emptystart.js - a blank canvas should invite, not accuse.
   2026-09-12.

   Reported (feedback item 4): opening a blank design shows the red badge "The
   design is empty" straight away. The customer has done nothing wrong, and
   nothing on screen says what to do first.

   MEASURED (live, ?product=custom-vinyl-banners, 0 layers): the badge is a
   <button> inside an <li class="is-block"> in the preflight list, visible from
   the first paint.

   WHAT THIS DOES, while the design has NO layers and the customer has not yet
   asked for the proof:
     - hides that one badge row (only the row whose text is "design is empty" -
       every other preflight warning is left alone).
   2026-09-14: the three starter buttons ("Start your design" / Choose a
   template / Upload a photo / Add text) were removed on the owner's request.

   The badge comes back the moment it is true and useful: as soon as the
   customer heads for the proof ("See check results" / Approve / Add to cart),
   or if they somehow reach that screen with an empty board. It is only
   suppressed on an untouched canvas.

   Nothing here touches layers, price, the cart or the print file.

   Diagnostics: window.__dcEmptyStart() */
(function () {
  'use strict';

  var TICK = 500, WINDOW_MS = 15 * 60 * 1000;

  var info = { hidBadge: false, asked: false, why: '' };
  window.__dcEmptyStart = function () { return info; };

  /* the customer is on their way to the proof - stop suppressing anything */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button, [role=button]');
    if (!b) return;
    var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
    if (/check results|approve|add to cart|proof/i.test(t)) info.asked = true;
  }, true);

  function api() {
    var a = window.__dcApi;
    return (a && a.front && Array.isArray(a.front.layers)) ? a : null;
  }

  function badgeRow() {
    var all = document.querySelectorAll('li, .issue, .preflight-item');
    for (var i = 0; i < all.length; i++) {
      var t = (all[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^the design is empty$/i.test(t)) return all[i];
    }
    return null;
  }

  function teardown() {
    var row = badgeRow();
    if (row) row.style.removeProperty('display');
    info.hidBadge = false;
  }

  var t0 = Date.now();
  var t = setInterval(function () {
    if (Date.now() - t0 > WINDOW_MS) { clearInterval(t); return; }
    var a = api();
    if (!a) return;

    var empty = a.front.layers.length === 0 && (!a.back || !a.back.layers || !a.back.layers.length);
    if (!empty || info.asked) { if (info.hidBadge) teardown(); return; }

    var row = badgeRow();
    if (row && row.style.display !== 'none') { row.style.display = 'none'; info.hidBadge = true; }
  }, TICK);

  addEventListener('pagehide', function () { clearInterval(t); });
})();
